import type {
  OkdocScenarioFamily,
  OkdocScenarioKind,
  OkdocScenarioProfile,
  OkdocSourceContext,
} from '@/features/okdoc/types';
import type { OkdocFlow } from '@/types/okdocTracking';

export interface OkdocLandingCatalogItem {
  key: string;
  tenant_id: string;
  tenant_name: string;
  tenant_slug: string;
  definition_id?: string;
  binding_id?: string;
  name: string;
  display_name: string;
  flow: OkdocFlow | string;
  scenario_kind: OkdocScenarioKind | string;
  scenario_family: OkdocScenarioFamily | string;
  source_context: OkdocSourceContext | string;
  origin_type: string;
  binding_scope?: string;
  resolution_source: string;
  prompt_text?: string;
  template_id?: string;
  template_name?: string;
  cluster_id?: string;
  cluster_name?: string;
  trigger_type?: string;
  channel?: string;
  is_active: boolean;
  updated_at: string;
  variant?: string;
}

export interface OkdocLandingCatalogResponse {
  items: OkdocLandingCatalogItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface OkdocLandingPreviewResponse {
  item: OkdocLandingCatalogItem;
  scenario_profile?: OkdocScenarioProfile;
  test_channels?: OkdocLandingTestChannel[];
  /** Из настроек тенанта (admin preview без фиктивных контактов). */
  clinic_name?: string;
  clinic_phone?: string;
  clinic_address?: string;
  clinic_website?: string;
}

export interface OkdocLandingTestChannel {
  channel: string;
  label: string;
  available: boolean;
  reason?: string;
  target_label?: string;
  target_value?: string;
}

export interface OkdocLandingDefinition {
  id: string;
  name: string;
  flow: OkdocFlow | string;
  scenario_kind: OkdocScenarioKind | string;
  scenario_family: OkdocScenarioFamily | string;
  source_context: OkdocSourceContext | string;
  origin_type: string;
  prompt_text?: string;
  scenario_profile?: OkdocScenarioProfile;
  metadata?: Record<string, unknown>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface OkdocLandingDefinitionResponse {
  definition: OkdocLandingDefinition;
}

export interface OkdocLandingCatalogFilters {
  tenant_id?: string;
  search?: string;
  flow?: OkdocFlow | '' | string;
  scenario_kind?: OkdocScenarioKind | '' | string;
  source_context?: OkdocSourceContext | '' | string;
  origin_type?: string;
  binding_scope?: string;
  limit?: number;
  offset?: number;
}

export interface OkdocLandingDefinitionRequest {
  tenant_id: string;
  definition_id: string;
}

export interface OkdocLandingDefinitionUpdateRequest extends OkdocLandingDefinitionRequest {
  name?: string;
  prompt_text?: string;
  scenario_profile?: OkdocScenarioProfile;
}

export interface OkdocLandingSendTestRequest {
  key: string;
  channel: string;
}

export interface OkdocLandingSendTestResponse {
  success: boolean;
  message: string;
  error?: string;
  target_label?: string;
  target_value?: string;
  target_channel?: string;
  shortlink_url?: string;
  rendered_text?: string;
}

export const OKDOC_LANDING_ORIGIN_LABELS: Record<string, string> = {
  template_profile: 'Template profile',
  legacy_preset: 'Legacy preset',
};

export const OKDOC_LANDING_BINDING_SCOPE_LABELS: Record<string, string> = {
  template: 'Template',
  service_cluster: 'Service cluster',
};

export const OKDOC_LANDING_RESOLUTION_SOURCE_LABELS: Record<string, string> = {
  database: 'DB binding',
  legacy_preset: 'Legacy preset',
};
